import * as clipboard from 'clipboard-polyfill'
import videojs from 'video.js'

const Button = videojs.getComponent('Button')

export class CopyLinkButton extends Button {
  constructor(player, options) {
    super(player, options)

    this.controlText(this.localize('Copy link'))
  }

  buildCSSClass() {
    return `vjs-fontawesome vjs-copy-link-button d-none d-md-block ${super.buildCSSClass()}`
  }

  handleClick() {
    clipboard.writeText(window.location.href)
  }
}
